export * from '../pesquisa/pesquisa.component';
export * from '../pesquisa/pesquisa-touch/pesquisa-touch.component';
export * from '../pesquisa/resultado-pesquisa/resultado-pesquisa.component';
export * from '../mapa/mapa.component';
export * from '../pesquisa/legenda/legenda.component';

//Generics
export * from '../paginator/paginator.component';


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/lib/component.ts
 **/